module.exports = __webpack_public_path__ + "static/gain-hero-9338a00a2676f9409df9eafa6a8bef7c.jpg";